import { LegalLayout, Clause, ContactClause } from "./LegalLayout";
import { useLang } from "../i18n/LanguageContext";

export default function PrivacyPolicy() {
  const { t } = useLang();
  const p = t.privacy;
  return (
    <LegalLayout title={p.title} updated={p.updated} testId="privacy-page">
      {p.clauses.map((c, i) => (
        <Clause key={i} heading={c.h}>
          {c.body.map((para, j) => <p key={j}>{para}</p>)}
        </Clause>
      ))}
      <ContactClause heading={p.contactHeading} lead={p.contactLead} />
    </LegalLayout>
  );
}
